import * as z from 'zod'

enum PaymentMethod {
  PONE_TIME_PAYMENT = 'oneTimePayment',
  SUBSCRIPTION = 'subscription'
}

export const subscriptionOfferSchema = z
  .object({
    id: z.string(),
    title: z.string(),
    subTitle: z.string(),
    bestOffer: z
      .object({
        isBestOffer: z.boolean().optional(),
        message: z.string().optional()
      })
      .optional(),
    subType: z.string(),
    paymentType: z.nativeEnum(PaymentMethod),
    benefits: z.array(z.string()),
    duration: z.number(),
    price: z.number(),
    discount: z.number(),
    fakePrice: z.number().optional().nullable()
  })
  .array()
